import { useApplication } from 'merchant-api/unified';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { queryClient } from 'merchant-api';
import { LDR } from 'merchant-api/types';
import { spiceroad } from '..';

export interface uploadDocumentsProps {
  response: any;
  documentsSending: boolean;
  uploadError: Error | null;
  upload: (files: FormData) => void;
  mutation: UseMutationResult<any, Error, FormData>;
}

export function uploadDocuments(): uploadDocumentsProps {
  const { opportunityId, partyId, applicationId } = useApplication();

  const mutation = useMutation({
    mutationFn: (arg: FormData) => {
      const urlParams = `opportunityId=${opportunityId}&partyId=${partyId}&applicationId=${applicationId}`;
      return spiceroad
        .post(`/v1/documents?${urlParams}`, arg, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((res) => res.data);
    },
    mutationKey: ['uploadDocuments', opportunityId],
    // The intake bank request only closes asynchronously downstream (SF automation), so a
    // successful upload must be authoritative in the cache: without this patch the step
    // mapper still sees an open bank request and bounces the wizard back to BANK_INFO.
    onSuccess: () => {
      queryClient.setQueryData<LDR[]>(['ldr', opportunityId], (rows) =>
        rows?.map((r) => (r.issueType === 'No bank statements' && r.status === 'REQUESTED' ? { ...r, status: 'MERCHANT_RESPONSE_SUBMITTED' } : r)),
      );
    },
  });

  return {
    response: mutation.data,
    documentsSending: mutation.isPending,
    uploadError: mutation.error,
    upload: mutation.mutateAsync,
    mutation,
  };
}

export default uploadDocuments;
